import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CutstrPipe } from './process-data.pipe';

const PIPE = [
    CutstrPipe
]

@NgModule({
    declarations: [...PIPE],
    imports: [CommonModule],
    exports: [...PIPE],
})
export class PipeModule {}
